import React from 'react';

type InstantTooltipProps = {
  text: string;
  children: React.ReactNode;
  position?: 'top' | 'bottom';
  align?: 'center' | 'start' | 'end';
};

const alignClasses = {
  center: 'left-1/2 -translate-x-1/2',
  start: 'left-0',
  end: 'right-0',
} as const;

const arrowAlignClasses = {
  center: 'left-1/2 -translate-x-1/2',
  start: 'left-3',
  end: 'right-3',
} as const;

export function InstantTooltip({
  text,
  children,
  position = 'top',
  align = 'center',
}: InstantTooltipProps) {
  const [visible, setVisible] = React.useState(false);

  return (
    <span
      className="relative inline-flex"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && (
        <span
          role="tooltip"
          className={`pointer-events-none absolute z-50 w-max max-w-[220px] rounded bg-charcoal-grey px-2.5 py-1.5 text-center text-[10px] leading-snug text-white shadow-lg ${
            position === 'top' ? 'bottom-full mb-1.5' : 'top-full mt-1.5'
          } ${alignClasses[align]}`}
        >
          {text}
          <span
            className={`absolute border-4 border-transparent ${arrowAlignClasses[align]} ${
              position === 'top'
                ? 'top-full border-t-charcoal-grey'
                : 'bottom-full border-b-charcoal-grey'
            }`}
          />
        </span>
      )}
    </span>
  );
}
